
import React, { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface InfoAlertProps {
  children: ReactNode;
  action?: {
    text: string;
    onClick?: () => void;
  };
}

const InfoAlert: React.FC<InfoAlertProps> = ({ children, action }) => {
  return (
    <div className="p-4 bg-blue-50 border-l-4 border-blue-400 mb-4">
      <div className="flex items-start gap-2">
        <Info className="h-5 w-5 text-blue-500 mt-0.5" />
        <div>
          <p className="text-sm text-blue-800">
            {children}
          </p>
          {action && (
            <Button variant="link" className="text-blue-600 p-0 h-auto text-sm" onClick={action.onClick}>
              {action.text}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoAlert;
